import { z } from 'zod';

export const WallpaperRelationType = z.enum(['similar', 'color_variant']);
export type WallpaperRelationType = z.infer<typeof WallpaperRelationType>;

export const WallpaperRelationRow = z.object({
  from_wallpaper_id: z.number().int().positive(),
  to_wallpaper_id: z.number().int().positive(),
  relation_type: WallpaperRelationType,
  sort: z.number().int().min(0),
});
export type WallpaperRelation = z.infer<typeof WallpaperRelationRow>;

export const WALLPAPER_RELATIONS: readonly WallpaperRelation[] = [
  // similar — kwiaty group
  { from_wallpaper_id: 1001, to_wallpaper_id: 1002, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1001, to_wallpaper_id: 1003, relation_type: 'similar', sort: 1 },
  { from_wallpaper_id: 1002, to_wallpaper_id: 1004, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1003, to_wallpaper_id: 1005, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1026, to_wallpaper_id: 1031, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1031, to_wallpaper_id: 1036, relation_type: 'similar', sort: 0 },
  // similar — morze group
  { from_wallpaper_id: 1006, to_wallpaper_id: 1007, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1007, to_wallpaper_id: 1008, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1027, to_wallpaper_id: 1032, relation_type: 'similar', sort: 0 },
  // similar — gory group
  { from_wallpaper_id: 1011, to_wallpaper_id: 1012, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1012, to_wallpaper_id: 1013, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1028, to_wallpaper_id: 1033, relation_type: 'similar', sort: 0 },
  // similar — miasto
  { from_wallpaper_id: 1016, to_wallpaper_id: 1017, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1017, to_wallpaper_id: 1018, relation_type: 'similar', sort: 0 },
  // color_variant — morze in different blue shades
  { from_wallpaper_id: 1006, to_wallpaper_id: 1009, relation_type: 'color_variant', sort: 0 },
  { from_wallpaper_id: 1007, to_wallpaper_id: 1009, relation_type: 'color_variant', sort: 0 },
  { from_wallpaper_id: 1022, to_wallpaper_id: 1009, relation_type: 'color_variant', sort: 0 },
  // color_variant — abstrakcja with color variants
  { from_wallpaper_id: 1021, to_wallpaper_id: 1022, relation_type: 'color_variant', sort: 0 },
  { from_wallpaper_id: 1021, to_wallpaper_id: 1023, relation_type: 'color_variant', sort: 1 },
  { from_wallpaper_id: 1021, to_wallpaper_id: 1024, relation_type: 'color_variant', sort: 2 },
  { from_wallpaper_id: 1021, to_wallpaper_id: 1025, relation_type: 'color_variant', sort: 3 },
  // color_variant — kwiaty color variants
  { from_wallpaper_id: 1001, to_wallpaper_id: 1004, relation_type: 'color_variant', sort: 0 },
  { from_wallpaper_id: 1002, to_wallpaper_id: 1005, relation_type: 'color_variant', sort: 0 },
  // similar — abstrakcja cross-group
  { from_wallpaper_id: 1021, to_wallpaper_id: 1035, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1035, to_wallpaper_id: 1040, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1040, to_wallpaper_id: 1045, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1045, to_wallpaper_id: 1050, relation_type: 'similar', sort: 0 },
  // similar — gory extended
  { from_wallpaper_id: 1011, to_wallpaper_id: 1015, relation_type: 'similar', sort: 1 },
  { from_wallpaper_id: 1033, to_wallpaper_id: 1038, relation_type: 'similar', sort: 0 },
  { from_wallpaper_id: 1038, to_wallpaper_id: 1043, relation_type: 'similar', sort: 0 },
] as const;

WALLPAPER_RELATIONS.forEach((r) => WallpaperRelationRow.parse(r));
